import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { c } from '@debbie/cortex/dist/index.js';
import { selectProcedures } from '@debbie/cortex/dist/procedures/selectors.js';
import Badge from '../Badge.js';
import THEME from '../../theme.js';
const TriggerPreview = (props) => {
    const procedures = useSelector(selectProcedures);
    const lang = useSelector((s) => s.lang);
    useEffect(() => {
        if (!procedures) {
            c.procedures.get();
        }
    }, []);
    const procedure = procedures?.find((p) => p.procedureId === props.procedureId);
    return (React.createElement("div", null, procedure && (React.createElement(React.Fragment, null,
        React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, lang.triggers[props.id]),
        React.createElement("p", null,
            React.createElement(Link, { to: `/settings/workflows/procedures/${props.procedureId}` }, lang.procedureTitles[props.procedureId] || procedure.title))))));
};
export default TriggerPreview;
//# sourceMappingURL=TriggerPreview.js.map